import { useAuthContext } from "@/context/auth/AuthContext";
import LoadAndDisplay from "@/context/LoadAndDisplay";
import axios from "axios";
import { useEffect, useState } from "react";

const Reviews = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [breadcrumb, setBreadcrumb] = useState([
    { name: "Subjects", base: "subjects" },
  ]);
  const [criteria, setCriteria] = useState({
    base: "subjects", // Initial base is 'subjects'
    limit: 100,
    search: "",
    searchBy: "",
  });

  const { user } = useAuthContext();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (user) {
        try {
          const response = await axios.get(
            `/api/video/${criteria.base}/?userId=${user.email}&limit=${
              criteria.limit
            }&search=${encodeURIComponent(criteria.search || "")}&searchBy=${
              criteria.searchBy || ""
            }`
          );

          if (response.status === 200) {
            setData(response.data.data);
          } else {
            console.error("Error fetching data");
          }
        } catch (err) {
          console.error("Fetch data error:", err);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [user, criteria]);

  const getTotalPerformance = () => {
    const performance = data.reduce((prev, curr) => {
      return curr.progressValue + prev;
    }, 0);
    return performance / data.length || 0;
  };

  const handleRowClick = (item) => {
    window.scrollTo({ top: 0 });
    if (criteria.base === "subjects") {
      setCriteria({
        base: "topics",
        limit: 100,
        search: item._id,
        searchBy: "subject.$id",
      });
      setBreadcrumb([
        ...breadcrumb,
        { name: item.displayName, base: "topics" },
      ]);
    } else if (criteria.base === "topics") {
      setCriteria({
        base: "subTopics",
        limit: 100,
        search: item._id,
        searchBy: "topic.$id",
      });
      setBreadcrumb([
        ...breadcrumb,
        { name: item.displayName, base: "subTopics" },
      ]);
    }
  };

  const handleBreadcrumbClick = (index) => {
    const newBreadcrumb = breadcrumb.slice(0, index + 1);
    const selectedCrumb = newBreadcrumb[index];

    setCriteria({
      base: selectedCrumb.base,
      limit: 100,
      search: "",
      searchBy: "",
    });

    setBreadcrumb(newBreadcrumb);
  };

  return (
    <>
      <div className="rbt-dashboard-content bg-color-white rbt-shadow-box">
        <div className="content">
          <div className="section-title">
            <h4 className="rbt-title-style-3">Performance</h4>
          </div>

          {/* Breadcrumb Navigation */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              {breadcrumb.map((crumb, index) => (
                <li
                  key={index}
                  className={`breadcrumb-item ${
                    index === breadcrumb.length - 1 ? "active" : ""
                  }`}
                  aria-current={
                    index === breadcrumb.length - 1 ? "page" : undefined
                  }
                  onClick={() => handleBreadcrumbClick(index)}
                >
                  {crumb.name}
                </li>
              ))}
            </ol>
          </nav>

          <div className="rbt-progress-style-1 mb--10">
            <div className="single-progress">
              <h6 className="title">Your Total Performance</h6>
              <div className="progress">
                <div
                  className="progress-bar wow fadeInLeft"
                  data-wow-duration="0.5s"
                  data-wow-delay=".3s"
                  role="progressbar"
                  style={{
                    width: `${Number(getTotalPerformance() * 100).toFixed(2)}%`,
                  }}
                  aria-valuenow={getTotalPerformance() * 100}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
                <span className="progress-number">
                  {Number(getTotalPerformance() * 100).toFixed(2)}%
                </span>
              </div>
            </div>
          </div>

          <div className="rbt-dashboard-table table-responsive mobile-table-750">
            <table className="rbt-table table-hover table table-borderless">
              <thead>
                <tr>
                  <th rowSpan={2}>Name</th>
                  <th>Lectures Consumption</th>
                  <th colSpan={2}>Question Bank</th>
                  <th>Overall Performance</th>
                </tr>
                <tr>
                  <th>Total </th>
                  <th>Total</th>
                  <th>Correct</th>
                  <th>Performance</th>
                </tr>
              </thead>
              <LoadAndDisplay isLoading={loading}>
                <tbody>
                  {data.map((subject) => (
                    <tr
                      className="cursor-pointer"
                      onClick={() => handleRowClick(subject)}
                      key={subject._id}
                    >
                      <td>
                        <span className="b3">{subject.displayName}</span>
                      </td>
                      <td>
                        <span className="b3">
                          {Number(subject.progressValue * 100).toFixed(2)}%
                        </span>
                      </td>
                      <td>
                        <span className="b3">0</span>
                      </td>
                      <td>
                        <span className="b3">0</span>
                      </td>
                      <td>
                        <span className="b3">
                          {Number(subject.progressValue * 100).toFixed(2)}%
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </LoadAndDisplay>
            </table>
            <div className="row">
              <div className="col-md-6 my-2 col-12">
                <div className="bg-gradient-7 rbt-shadow-box">
                  <h4 className="rbt-title-style-3 text-white">Strength</h4>
                  <ul className="plan-offer-list rbt-list-white-opacity ">
                    {data.filter((item) => {
                      return Number(item.progressValue * 100).toFixed(0) > 70;
                    }).length > 0 ? (
                      data
                        .filter((item) => {
                          return (
                            Number(item.progressValue * 100).toFixed(0) > 70
                          );
                        })
                        .map((item) => (
                          <li
                            key={item._id} // Unique key based on the ID
                            className="color-white"
                          >
                            <i className="feather-check"></i> {item.displayName}
                          </li>
                        ))
                    ) : (
                      <li className="color-white">
                        <i className="feather-minus"></i>Nothing to display
                      </li>
                    )}
                  </ul>
                </div>
              </div>
              <div className="col-md-6 my-2 col-12">
                <div className="bg-gradient-7 rbt-shadow-box">
                  <h4 className="rbt-title-style-3 text-white">Weakness</h4>
                  <ul className="plan-offer-list rbt-list-white-opacity">
                    {data.filter((item) => {
                      return (
                        Number(item.progressValue * 100).toFixed(0) < 70 &&
                        Number(item.progressValue * 100).toFixed(0) > 20
                      );
                    }).length > 0 ? (
                      data
                        .filter((item) => {
                          return (
                            Number(item.progressValue * 100).toFixed(0) < 70 &&
                            Number(item.progressValue * 100).toFixed(0) > 20
                          );
                        })
                        .map((item) => (
                          <li
                            key={item._id} // Unique key based on the ID
                            className="color-white"
                          >
                            <i className="feather-check"></i> {item.displayName}
                          </li>
                        ))
                    ) : (
                      <li className="color-white">
                        <i className="feather-minus"></i>Nothing to display
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reviews;
